import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { normalizeCourierServices } from '../../../../services/helpers/courier';
import { 
    ActionSection,
    HistoryView, 
    AddressDetail, 
    DeliveryDetail, 
    ItemDetail,
    WaybillDetail, 
    CourierDetail, 
    PriceDetail 
} from "./components";
import { getOrder, deleteOrder, updateOrderStatus } from "../../../../store/action/order";
import moment from "moment";
import Modal from '../../../../components/molecules/Modal';
import { isAuthenticated } from '../../../../store/action/auth';
import { trackEvent } from "../../../../services/analytics";
import Formatter from '../../helpers/formatter'
const cancelReasons = [
    "Pilih...",
    "Ingin mengganti kurir",
    "Waktu penjemputan terlalu lama",
    "Tidak ada konfirmasi",
    "Ingin mengganti alamat",
    "Harga kurir tidak sesuai",
    "Barang belum siap",
    "Lainnya"
];

const View = (props) => {
    const { token } = isAuthenticated();
    const [ loading, setLoading ] = useState(true);
    const [ cancellationReason, setCancellationReason ] = useState('');
    const [ deleteMode, setDeleteMode ] = useState(false);
    const [ order, setOrder ] = useState({
        items:[],
        courierHistory:[]
    });
    
    useEffect(() => {
        _fetchData()
    },[props.orderId]);

    
    const _fetchData = async () => {
        if (props.orderId) {
            setLoading(true)
            try {      
                const res = await getOrder(token, props.orderId);
                
                if (res.success) {
                    setOrder(Formatter.OpenAPItoOrder(res))
                } else {
                    console.log (res.error);
                    alert('Gagal ambil informasi pengiriman')
                }
            } catch (err) {
                console.log(err);
                alert('Gagal ambil informasi pengiriman')
            }
            setLoading(false);
        }
    }

    const onDeleteOrder = async () => {
        if (cancellationReason === '' || cancellationReason === 'Pilih...') {
          alert("Pilih alasan kenapa Anda cancel.");
          return
        }
        deleteOrder(token, order.orderId, cancellationReason,'production')
          .then(async res => {
            if(res.success){
              await trackEvent("Order Cancelled",{
                action: "track",
                category: "Orders",
                label: 'Cancel Order From Dashboard',
                event: "Click"
              });
    
              alert(`Berhasil dihapus`);
              window.location.reload()
            } else {
              alert(res.error)
            }
        });
    };
    
      
    const onUpdateOrder = () => {
        if(window.confirm('Kami akan segera mempesan order kamu. Kamu yakin?')) {
        updateOrderStatus(token, order.orderId,'confirmed','production')
            .then(res => {
            if(res.success){
                alert(`Kami segera mempesan. Mohon ditunggu :)`);
                window.location.reload()
            } else {
                alert(res.error)
            }
            })
        }
    };

    
    const { companyName, typeView } = normalizeCourierServices(order.courierCompany,order.courierType);

    const body = (
        <Row className="m-0">
            <Col sm={7} className="p-2">
                <small className="p-2">ORDER ID: {order.orderId}</small>
                <Row>
                    <Col>
                        <WaybillDetail 
                            waybillId={order.courierWaybillId} 
                            link={order.courierLink}
                        />
                    </Col>
                    <Col>
                    <CourierDetail 
                        courier={companyName}
                        type={typeView}
                    />
                    </Col>
                </Row>
                <AddressDetail 
                    title={"Alamat Asal"}
                    name={order.originName}
                    phone={order.originPhone}
                    address={order.originLocation}
                    note={order.originNote}
                />
                <div className="p-1"/>
                <AddressDetail 
                    title={"Alamat Tujuan"}
                    name={order.receiverName}
                    phone={order.receiverPhone}
                    address={order.receiverLocation}
                    note={order.receiverNote}
                />
                <Row>
                    <Col>
                        <DeliveryDetail 
                            date={order.deliveryDate}
                            time={order.deliveryTime}
                        />
                    </Col>
                    <Col>
                        <PriceDetail price={order.price}/>
                    </Col>
                </Row>
                <ItemDetail items={order.items}/>
            </Col>
            <Col sm={5} className="px-2 py-0 bg-lighter border-left">
                <HistoryView history={order.courierHistory}/>
            </Col>
        </Row>
    )
    

    if (deleteMode) { 
        return (
            <Modal
                buttons
                type="oneButton"
                bClick={() => onDeleteOrder()}
                show={props.show}
                onHide={props.onHide}
                title="Alasan Cancel"
                bodyClassName="p-0"
                bText={`Lanjut Batalkan`}
                size={"md"}
            >
                <div className="p-4">
                    <select
                        id="inputState"
                        className="form-control"
                        onChange={e => setCancellationReason(e.target.value)}
                    >
                        {
                        cancelReasons.map((i,idx) => (
                            <option
                                key={idx}
                                value={i}
                                className={`${idx === 0 ? "selected":""}`}
                            >
                                {i}
                            </option>
                        ))
                        }
                    </select>
                </div>
            </Modal>
        )
    }

    return (
        <Modal
            buttons={!loading}
            type="custom"
            footerComponent={
                <ActionSection 
                    onClickConfirm={() => onUpdateOrder()}
                    onClickCancel={() => setDeleteMode(true)}
                    onClickPrint={props.onClickPrint}
                    order={order}
                />
            }
            show={props.show}
            onHide={props.onHide}
            title={"Detail Pesanan"}
            bodyClassName="p-0"
            size={"lg"}
        >
            {
                loading ? 
                    <div className="p-2">Mengambil order...</div> : body
                   
            }
        </Modal>
    )
}
export default View

